import type { SVGProps } from 'react';
const DawnFlagCD = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CD_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-CD_svg__a)">
      <rect width={22} height={16} fill="#158AFF" rx={2} />
      <path
        fill="#FDD216"
        fillRule="evenodd"
        d="m25.425 4.164-27.07 14.043-2.853-5.702L22.572-1.54z"
        clipRule="evenodd"
      />
      <path fill="#CE1120" d="m25.238 3.019-27.07 14.044-1.902-3.802L23.336-.783z" />
      <path
        fill="#FDD216"
        fillRule="evenodd"
        d="m3.667 4.773-1.54 1.118.568-1.836-1.519-1.146 1.89-.017.6-1.825.601 1.825 1.89.017-1.519 1.146.568 1.836z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagCD;
